import * as Models from "../ts/rlAdmin.models";
import * as Consts from "../ts/rlAdmin.consts";
import * as Utils from "../ts/rlAdmin.utils";
import * as moment from "moment";
import { EntityConfigService } from "../services/entity-config-service";
import { AccountService } from "../services/account-service";
import { LocalCacheService } from "../services/local-cache-service";
import { EntityService } from "../services/entity-service";
import { NotifyService } from "../services/notify-service";
import { EventService } from "../services/event-service";
import { SearchService } from "../services/search-service";
import { CustomViewsService } from "../services/custom-views-service";

export function RLAssociationTable(): ng.IDirective {
    return {
        restrict: 'E',
        bindToController: true,
        controller: RLAssociationTableController,
        controllerAs: 'atVM',
        scope: {
            charTypeID: '=charTypeId',
            entityDocuments: '=',
            visibility: '=',
            locked: '=',
            canEdit: '=',
            isParentChar: "=",
            entityID: "=entityId",
            refreshPanel: "=",
            initialized: '=?',
            customColumns: '=?',
            templateMetaData: '=?',
            sortDir: '=?',
            sortField: '=?',
            page: '=?',
            pageCount: '=?',
            rowCount: '=?',
            numFound: '=?',
            selectable: '=?',
            selectedItems: '=?',
            selectedItemsArray: '=?',
            selectedRecordsForCharType: "=?"
        },
        template: require("/assets/app/templates/association-table.html")
    }
}

class RLAssociationTableController {
    static $inject = ['$scope', '$q', "$rootScope", "$filter", "$location", "$window", 'entityConfigService', 'accountService', 'localCacheService', "entityService", "notifyService", "eventService", "searchService", 'customViewsService'];

    charTypeID: number;
    selectable: boolean;
    allChecked: boolean;
    page: number;
    pageCount: number;
    rowCount: number;
    numFound: number;

    // not really a fan of this but sticking with the way it was already done in contact and catalog search controllers
    selectedItems: { [recIDTitle: string]: boolean } = {};
    selectedItemsArray: Models.IEntitySearchDoc[] = [];

    initialized: boolean;
    visibility: number;

    availableColumns: Models.IListTableColumn[];

    customColumns: Models.ICustomUserColumns;

    selectedListID: string;
    charTypeUrl: string;

    entityDocuments: Models.IEntitySearchDoc[];
    rows: Models.IListTableRow[];

    //Association Table specific
    locked: boolean;
    canEdit: boolean;
    isParentChar: boolean;
    entityID: string;
    refreshPanel: boolean;
    //--       
    sortDir: number
    removeRecordID: number;
    deleteRecordNotifiationText: string;
    removeRecordAssoctaionModalOpen: boolean;
    parentCharTypeName: string;
    charTypeName: string;
    selectedRecords: { [recID: number]: boolean } = {};
    selectedRecordsForCharType: { [childCharTypeID: number]: Models.IListTableRow[] };

    catalogHierarchy: Models.ICatalogHierarchy[];
    catalogHierarchyIDTitles: { [recTitle: string]: number } = {};
    catalogRecordHierarchy: { [recID: number]: Models.ICatalogHierarchy[] } = {};
    catalogRecTopMostParents: { [recID: number]: string[] } = {};
    catalogRecDirectParents: { [recID: number]: string[] } = {};
    catalogRecHierarchyPaths: { [recID: number]: string } = {};
    currentPreviewEntityID: string;

    associatedCatalogTitleIDDictionary: { [recTitle: string]: number } = {};
    associatedCatalogTitleDictionary: { [rowRecordId: number]: string[] } = {};
    associatedCatalogRecIDDictionary: { [rowRecordId: number]: number[] } = {};

    associatedDealTitleIDDictionary: { [recTitle: string]: number } = {};
    associatedDealTitleDictionary: { [rowRecordId: number]: string[] } = {};
    associatedDealRecIDDictionary: { [rowRecordId: number]: number[] } = {};


    constructor(
        $scope: ng.IScope,
        private $q: ng.IQService,
        private $rootScope: ng.IRootScopeService,
        private $filter: ng.IFilterService,
        private $location: ng.ILocationService,
        private $window: ng.IWindowService,
        private entityConfigService: EntityConfigService,
        private accountService: AccountService,
        private cacheService: LocalCacheService,
        private entityService: EntityService,
        private notifyService: NotifyService,
        private eventService: EventService,
        private searchService: SearchService,
        private customViewsService: CustomViewsService) {

        this.sortDir = 0;
        this.deleteRecordNotifiationText = "";
        this.parentCharTypeName = "";
        this.charTypeName = "";

        $scope.$watch(() => this.charTypeID, (newValue, oldValue) => {
            this.charTypeUrl = Utils.UrlBuilder.getCharTypeSummaryUrl(this.charTypeID);
            this.getCharacteristicList(this.charTypeID);
        });

        $scope.$watchCollection(() => [this.entityDocuments, this.customColumns, this.availableColumns], (newValue, oldValue) => {
            if (this.customColumns && this.entityDocuments && this.availableColumns) {
                if (this.charTypeID == Consts.CharTypeIDs.transaction) {
                    var isAssociatedRecordColumnSelected = _.find(this.customColumns.columns, c => c.solrLabel == ('associated_catalog'));
                    if (isAssociatedRecordColumnSelected) {
                        this.getAssociatedFieldValues(Consts.CharTypeIDs.property.toString())
                            .then(() => {
                                this.setupRows(this.entityDocuments, this.customColumns.columns);
                            });
                    }
                    else {
                        this.setupRows(this.entityDocuments, this.customColumns.columns);
                    }
                }
                else if (this.charTypeID == Consts.CharTypeIDs.user) {
                    var isAssociatedCatalogColumnSelected = _.find(this.customColumns.columns, c => c.solrLabel == ('associated_catalog'));
                    var isAssociatedDealRecordColumnSelected = _.find(this.customColumns.columns, c => c.solrLabel == ('associated_deal'));
                    var promises = [];

                    if (isAssociatedCatalogColumnSelected) {
                        promises.push(this.getAssociatedFieldValues(Consts.CharTypeIDs.property.toString()));
                    }

                    if (isAssociatedDealRecordColumnSelected) {
                        promises.push(this.getAssociatedFieldValues(Consts.CharTypeIDs.transaction.toString()));
                    }

                    if (promises.length > 0) {
                        $q.all(promises)
                            .then(() => {
                                this.setupRows(this.entityDocuments, this.customColumns.columns);
                            });
                    }
                    else {
                        this.setupRows(this.entityDocuments, this.customColumns.columns);
                    }
                }
                else if (this.charTypeID == Consts.CharTypeIDs.inventory) {
                    var isAssociatedRecordColumnSelected = _.find(this.customColumns.columns, c => c.solrLabel == ('associated_catalog'));
                    if (isAssociatedRecordColumnSelected) {
                        this.getAssociatedFieldValues(Consts.CharTypeIDs.property.toString())
                            .then(() => {
                                this.setupRows(this.entityDocuments, this.customColumns.columns);
                            });
                    }
                    else {
                        this.setupRows(this.entityDocuments, this.customColumns.columns);
                    }
                } else if (this.charTypeID == Consts.CharTypeIDs.property) {
                    var isTopParentColumnSelected = _.find(this.customColumns.columns, c => c.solrLabel == 'top_parent');
                    var isDirectParentColumnSelected = _.find(this.customColumns.columns, c => c.solrLabel == 'direct_parent');
                    var isAssociatedDealRecordColumnSelected = _.find(this.customColumns.columns, c => c.solrLabel == ('associated_deal'));

                    this.catalogHierarchy = [];
                    this.catalogHierarchyIDTitles = {};
                    this.catalogRecordHierarchy = {};
                    this.catalogRecDirectParents = {};
                    this.catalogRecTopMostParents = {};
                    this.catalogRecHierarchyPaths = {};

                    if (isTopParentColumnSelected || isDirectParentColumnSelected || isAssociatedDealRecordColumnSelected) {
                        var promises = [];

                        if (isTopParentColumnSelected || isDirectParentColumnSelected) {
                            var catalogRecordIDs: number[] = [];
                            catalogRecordIDs = this.entityDocuments.map(e => e.recordID);
                            promises.push(this.entityConfigService.getCatalogHierarchy(catalogRecordIDs.join(','))
                                .then((result) => {
                                    if (result.success) {
                                        this.catalogHierarchy = result.data;

                                        _.forEach(catalogRecordIDs, (recID) => {
                                            var catalogRecHierarchy = _.filter(this.catalogHierarchy, c => c.recID == recID);

                                            var directParentTitles = catalogRecHierarchy.map(h => h.directParentTitle).filter(function (e, i, a) {
                                                return i === a.indexOf(e);
                                            });
                                            this.catalogRecDirectParents[recID] = directParentTitles;

                                            var topParentTitles = catalogRecHierarchy.map(h => h.topMostParentTitle).filter(function (e, i, a) {
                                                return i === a.indexOf(e);
                                            });
                                            this.catalogRecTopMostParents[recID] = topParentTitles;

                                            var hierarchyPaths = catalogRecHierarchy.map(h => h.hierarchyPath).filter(function (e, i, a) {
                                                return i === a.indexOf(e);
                                            });
                                            this.catalogRecHierarchyPaths[recID] = hierarchyPaths.join('\n');
                                        });

                                        _.forEach(this.catalogHierarchy, (ch) => {
                                            if (!this.catalogHierarchyIDTitles[ch.directParentTitle]) {
                                                this.catalogHierarchyIDTitles[ch.directParentTitle] = ch.directParentRecID;
                                            }

                                            if (!this.catalogHierarchyIDTitles[ch.topMostParentTitle]) {
                                                this.catalogHierarchyIDTitles[ch.topMostParentTitle] = ch.topMostParentRecID;
                                            }
                                        });
                                    }
                                }));
                        }

                        if (isAssociatedDealRecordColumnSelected) {
                            promises.push(this.getAssociatedFieldValues(Consts.CharTypeIDs.transaction.toString()));
                        }

                        $q.all(promises)
                            .then(() => {
                                this.setupRows(this.entityDocuments, this.customColumns.columns);
                            });
                    }
                    else {
                        this.setupRows(this.entityDocuments, this.customColumns.columns);
                    }
                }
                else {
                    this.setupRows(this.entityDocuments, this.customColumns.columns);
                }
            }
        });

        // TODO: Fix the way selection works with this directive period
        // This is a 'temp' hack to work with entity-quick-search
        $scope.$watch(() => this.selectedItems, (newValue) => {
            this.selectedItemsArray = [];
            for (var recID in this.selectedItems) {
                if (this.selectedItems[recID] === true) {
                    this.selectedItemsArray.push(_.find(this.entityDocuments, (doc) => {
                        return doc.recordID + '|' + doc.title == recID;
                    }));
                }
            }
        }, true);

        $scope.$on(Consts.Events.RefreshViewEntity, (e, data) => {
            if (!_.isEmpty(data)) {
                this.currentPreviewEntityID = data;
            }
            else {
                this.currentPreviewEntityID = "";
            }
        });
    }

    private setupRows(itemRows: Models.IEntitySearchDoc[], customColumns: Models.ICustomUserColumn[]) {
        var divID = Utils.IdBuilder.splitEntityID(this.entityID).divID;
        var specialColumns = this.customViewsService.GetSpecialColumns(this.charTypeID);

        customColumns.forEach((col) => {
            if (col.solrLabel.indexOf('_date') > -1 || col.solrLabel.indexOf('_updated') > -1 || col.solrLabel == 'created') {
                col.formatter = 'dateLocal:"L"';
            }

            // nearly duplicate of code from column-picker.ts, refactor
            if (col.solrLabel.indexOf('_') > -1) {
                var split = col.solrLabel.split('_');
                col.label = '';
                split.forEach((val) => {
                    col.label += val.substr(0, 1).toUpperCase() + val.substr(1, val.length - 1) + ' ';
                });
            } else if (col.solrLabel == 'userlabel') {
                col.label = 'Contact';
            } else if (col.solrLabel == 'companylabel') {
                col.label = 'Company';
            } else if (col.solrLabel == 'created') {
                col.label = 'Created';
            }

            if (col.solrLabel == 'transaction_id') {
                col.label = 'Deal ID';
            }
        });

        this.rows = [];
        itemRows.forEach((row) => {
            var sortedColumns = _.sortBy(customColumns, (col) => { return col.sequenceNumber; });

            var columns: Models.IListTableColumn[] = [];
            sortedColumns.forEach((col) => {
                if (col.characteristicID) {
                    var characteristic = _.find(this.availableColumns, (aCol) => {
                        return aCol.characteristicID === col.characteristicID;
                    });

                    // actual characteristic
                    if (row.characteristics[characteristic.solrLabel]) {
                        columns.push({
                            characteristicID: col.characteristicID,
                            solrLabel: characteristic.solrLabel,
                            label: characteristic.label || characteristic.solrLabel,
                            value: _.isArray(row.characteristics[characteristic.solrLabel]) ? row.characteristics[characteristic.solrLabel][0] : row.characteristics[characteristic.solrLabel],
                            formatter: characteristic.formatter,
                            dataTypeID: characteristic.dataTypeID,
                            systemIndicatorID: characteristic.systemIndicatorID
                        });
                    }
                    // header-level
                    else if (row[characteristic.solrLabel]) {
                        columns.push({
                            characteristicID: col.characteristicID,
                            solrLabel: characteristic.solrLabel,
                            label: characteristic.label,
                            value: row[characteristic.solrLabel],
                            formatter: characteristic.formatter,
                            dataTypeID: characteristic.dataTypeID,
                            systemIndicatorID: characteristic.systemIndicatorID
                        });
                    }
                    else if (characteristic) {
                        columns.push({
                            characteristicID: -1,
                            solrLabel: col.solrLabel,
                            label: characteristic.label,
                            value: undefined,
                            dataTypeID: -1,
                            systemIndicatorID: -1
                        });
                    }
                    // missing from this record
                    else {
                        columns.push({
                            characteristicID: -1,
                            solrLabel: col.solrLabel,
                            label: col.label,
                            value: undefined,
                            dataTypeID: -1,
                            systemIndicatorID: -1
                        });
                    }
                }
                else if (col.solrLabel) {
                    var characteristic = _.find(this.availableColumns, (aCol) => {
                        return aCol.solrLabel === col.solrLabel;
                    });

                    var specialCol = _.find(specialColumns, (sCol) => {
                        return sCol.solrLabel == col.solrLabel;
                    });
                    var test = this.customViewsService.GetDefaultColumns(this.charTypeID).columns;
                    var defaultCol = _.find(test, (dCol) => {
                        return dCol.solrLabel == col.solrLabel;
                    });

                    if (specialCol) {
                        col.label = specialCol.label;
                    }
                    else if (defaultCol) {
                        col.label = defaultCol.label;
                    }

                    // actual characteristic
                    if (characteristic) {
                        columns.push({
                            characteristicID: col.characteristicID,
                            solrLabel: characteristic.solrLabel,
                            label: characteristic.label,
                            value: row[characteristic.solrLabel] || row.characteristics[characteristic.solrLabel],
                            formatter: characteristic.formatter,
                            dataTypeID: characteristic.dataTypeID,
                            systemIndicatorID: characteristic.systemIndicatorID
                        });
                    }
                    // header value
                    else if (row[col.solrLabel]) {
                        columns.push({
                            characteristicID: -1,
                            solrLabel: col.solrLabel,
                            label: col.label,
                            value: row[col.solrLabel],
                            formatter: col.formatter,
                            dataTypeID: -1,
                            systemIndicatorID: -1
                        });
                    }
                    // specially indexed value that is not an actual characteristic
                    else if (row.characteristics[col.solrLabel]) {
                        columns.push({
                            characteristicID: -1,
                            solrLabel: col.solrLabel,
                            label: col.label || col.solrLabel,
                            value: row.characteristics[col.solrLabel],
                            formatter: col.formatter,
                            dataTypeID: -1,
                            systemIndicatorID: -1
                        });
                    }
                    //hack for showing catalog hierarchy
                    else if (col.solrLabel == 'top_parent' || col.solrLabel == 'direct_parent') {
                        columns.push({
                            characteristicID: -1,
                            solrLabel: col.solrLabel,
                            label: col.label || col.solrLabel,
                            value: '',
                            formatter: col.formatter,
                            dataTypeID: -1,
                            systemIndicatorID: -1,
                            multipleIndicator: -1
                        });
                    }
                    // header value with underscore - we need to access value without but sort with
                    else if (col.solrLabel.indexOf('_') > -1) {
                        var split = col.solrLabel.split('_');
                        var label = split[0];
                        split.splice(0, 1);

                        split.forEach((val) => {
                            label += val.substr(0, 1).toUpperCase() + val.substr(1, val.length - 1);
                        });

                        columns.push({
                            characteristicID: -1,
                            solrLabel: col.solrLabel,
                            label: col.label || col.solrLabel,
                            value: row[label],
                            formatter: col.formatter,
                            dataTypeID: -1,
                            systemIndicatorID: -1
                        });
                    }
                    // dummy value
                    else {
                        columns.push({
                            characteristicID: -1,
                            solrLabel: col.solrLabel,
                            label: col.label || col.solrLabel,
                            value: undefined,
                            dataTypeID: -1,
                            systemIndicatorID: -1
                        });
                    }
                }
            });

            this.rows.push({
                recordID: row.recordID,
                columns: columns,
                recordRevisionID: row.recordRevisionID,
                title: row.title,
                currency: row.characteristics['currency_str'],
                entityID: Utils.IdBuilder.buildEntityID(divID, this.charTypeID, row.recordID)
            });
        });

        this.initialized = true;
    }

    private getCharacteristicList(charTypeID: number) {
        return this.entityConfigService.getCharacteristicList(charTypeID)
            .then((res) => {
                var columns = _.sortBy(res, (chr) => {
                    return chr.label;
                }).map((chr): Models.IListTableColumn => {
                    return {
                        solrLabel: Utils.CharUtil.GetCharSolrLabel(chr.dataTypeID, chr.multipleIndicator, chr.tagLabel),
                        label: chr.label,
                        characteristicID: chr.characteristicID,
                        formatter: Utils.CharUtil.GetFormatter(chr.dataTypeID),
                        dataTypeID: chr.dataTypeID,
                        systemIndicatorID: chr.systemIndicator
                    }
                });

                this.availableColumns = columns;
            });
    }

    private setCustomColumnList(charTypeID: number, headerID: string) {
        var key = `CC-${charTypeID}-${headerID}`;
        var colList = this.cacheService.getItem(key);

        if (!colList) {
            this.getCustomListColumns()
                .then(() => {

                });
        }
    }

    private getCustomListColumns() {
        return this.accountService.getCustomColumns()
            .then((res) => {
                var dayExp = moment.duration(1, 'day');
                res.forEach((customColumns) => {
                    this.cacheService.setItem(`CC-${customColumns.charTypeID}-${customColumns.headerID}`, customColumns, dayExp);
                });
            });
    }

    ToggleSelectAllRecords() {
        if (!_.isEmpty(this.selectedRecordsForCharType[this.charTypeID]) && this.selectedRecordsForCharType[this.charTypeID].length == this.rows.length) {
            this.selectedRecordsForCharType[this.charTypeID] = [];
        }
        else {
            var selectedRecords: Models.IListTableRow[] = [];
            _.forEach(this.rows, (itemRow) => {
                selectedRecords.push(itemRow);
            });
            this.selectedRecordsForCharType[this.charTypeID] = selectedRecords;
        }
    }

    //Association Table specific
    //The rest of this logic is the same as with list-table.ts
    RemoveAssociation(recordID: number) {
        var parsedEntityID = Utils.IdBuilder.splitEntityID(this.entityID);

        if (parsedEntityID.charTypeID == Consts.CharTypeIDs.transaction && this.charTypeID == Consts.CharTypeIDs.property) {
            this.entityService.getExistingCatalogItemsFromDealToInvoices(parsedEntityID.recID, [recordID])
                .then((result) => {
                    var breakDelete: boolean = false;
                    if (result.success) {
                        breakDelete = _.any(result.data, r => r == recordID);
                    }
                    else {
                        breakDelete = true;
                    }

                    if (breakDelete) {
                        this.$window.alert("Unable to delete this catalog item because there are one or more associated accounting records.");
                    }
                    else {
                        this.processRemoveAssocation(recordID);
                    }
                });
        }
        else {
            this.processRemoveAssocation(recordID);
        }
    }

    private processRemoveAssocation(recordID: number) {
        this.removeRecordID = recordID;
        var parsedEntityID = Utils.IdBuilder.splitEntityID(this.entityID);
        this.parentCharTypeName = Utils.CharTypeUtil.GetCharTypeName(parsedEntityID.charTypeID);
        this.charTypeName = Utils.CharTypeUtil.GetCharTypeName(this.charTypeID);
        var entityTitle = _.find(this.entityDocuments, e => e.recordID == recordID).title;

        if (this.charTypeID == Consts.CharTypeIDs.project || this.charTypeID == Consts.CharTypeIDs.property) {
            if (parsedEntityID.charTypeID == Consts.CharTypeIDs.transaction) {
                if (this.charTypeID == Consts.CharTypeIDs.property) {
                    this.deleteRecordNotifiationText = entityTitle + " and related Catalog Items will be removed from any Rights, Tables and Amounts on this Deal. <br/> Are you sure you want to remove this association?"
                }
                else {
                    this.deleteRecordNotifiationText = entityTitle + " will be removed from any Tables on this Deal.<br/> Are you sure you want to remove this association?"
                }
            }
            else {
                this.deleteRecordNotifiationText = entityTitle + " will be removed from any Tables on this " + this.parentCharTypeName + ".<br/> Are you sure you want to remove this association?"
            }
            this.removeRecordAssoctaionModalOpen = true;
        }
        else {
            this.removeRecordAssoctaionModalOpen = true;
            this.deleteRecordNotifiationText = entityTitle + " will be removed from this " + this.parentCharTypeName + ".<br/> Are you sure you want to remove this association?"
        }
    }

    private RemoveAssociationToRecord() {
        this.notifyService.startProgress();
        var parsedEntityID = Utils.IdBuilder.splitEntityID(this.entityID);
        var childEntityID = Utils.IdBuilder.buildEntityID(parsedEntityID.divID, this.charTypeID, this.removeRecordID);
        var parentEntity = this.entityID;
        var childEntity = childEntityID;

        if (this.isParentChar) {
            parentEntity = childEntityID;
            childEntity = this.entityID;
        }

        this.entityService.deleteAssociation(parentEntity, childEntity)
            .then(() => {
                var itemRow = _.find(this.entityDocuments, ir => { return ir.entityID == childEntityID; });
                _.remove(this.entityDocuments, i => i == itemRow);
                this.numFound = this.entityDocuments.length;
                this.eventService.call(Consts.Events.ValidateEntity)
                    .then(() => {
                        this.notifyService.notifySuccess("Association removed");
                    });
            })
            .finally(() => {
                this.removeRecordID = 0;
                this.deleteRecordNotifiationText = "";
                this.removeRecordAssoctaionModalOpen = false;
                this.removeRecordID = 0;
                this.refreshPanel = true;
                this.notifyService.endProgress();
            });
    }

    PreviewEntity(recordID: number) {
        var parsedEntityID = Utils.IdBuilder.splitEntityID(this.entityID);
        var rowEntityID = Utils.IdBuilder.buildEntityID(parsedEntityID.divID, this.charTypeID, recordID);
        this.currentPreviewEntityID = rowEntityID;
        this.$rootScope.$broadcast(Consts.Events.ViewEntity, rowEntityID);
    }
    //--		

    private getAssociatedFieldValues(otherCharTypeID: string): ng.IPromise<any> {
        var recordIDs: number[] = [];
        recordIDs = this.entityDocuments.map(e => e.recordID);

        return this.entityConfigService.getAssociatedList(this.charTypeID, recordIDs.join(','), "", otherCharTypeID)
            .then((result) => {
                if (result.success) {
                    let associatedItemsFiltered = _.filter(result.data, c => c.associatedCharTypeID.toString() == otherCharTypeID);
                    this.setAssociatedItems(recordIDs, _.parseInt(otherCharTypeID), associatedItemsFiltered);
                }
            });
    }

    private setAssociatedItems(recordIDs: number[], associatedCharTypeID: number, associatedItems: Models.IAssociatedItem[]) {
        if (associatedCharTypeID == Consts.CharTypeIDs.transaction) {

            _.forEach(associatedItems, (item) => {
                if (this.associatedDealTitleIDDictionary[item.associatedRecTitle] == undefined) {
                    this.associatedDealTitleIDDictionary[item.associatedRecTitle] = item.associatedRecID;
                }
            });

            for (var i = 0; i < recordIDs.length; i++) {
                let associatedItemToRecordArray = _.filter(associatedItems, c => c.recID == recordIDs[i]).map(function (elem) {
                    return elem.associatedRecTitle;
                });

                let associatedItemToRecordIDArray = _.filter(associatedItems, c => c.recID == recordIDs[i]).map(function (elem) {
                    return elem.associatedRecID;
                });

                this.associatedDealTitleDictionary[recordIDs[i]] = associatedItemToRecordArray;
                this.associatedDealRecIDDictionary[recordIDs[i]] = associatedItemToRecordIDArray;
            };

        }
        else if (associatedCharTypeID == Consts.CharTypeIDs.property) {

            _.forEach(associatedItems, (item) => {
                if (this.associatedCatalogTitleIDDictionary[item.associatedRecTitle] == undefined) {
                    this.associatedCatalogTitleIDDictionary[item.associatedRecTitle] = item.associatedRecID;
                }
            });

            for (var i = 0; i < recordIDs.length; i++) {
                let associatedItemToRecordArray = _.filter(associatedItems, c => c.recID == recordIDs[i]).map(function (elem) {
                    return elem.associatedRecTitle;
                });

                let associatedItemToRecordIDArray = _.filter(associatedItems, c => c.recID == recordIDs[i]).map(function (elem) {
                    return elem.associatedRecID;
                });

                this.associatedCatalogTitleDictionary[recordIDs[i]] = associatedItemToRecordArray;
                this.associatedCatalogRecIDDictionary[recordIDs[i]] = associatedItemToRecordIDArray;
            };

        }
    }
}
